import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getAdCount } from "@/api/data";
import infoList from "@/mixins/infoList";
import serverList from "../../components/serverList/serverOptions.vue";
import VxeTable from "@/components/vxeTable/vxeTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    VxeTable: VxeTable,
    DataOptions: DataOptions
  },
  data: function data() {
    var h = this.$createElement;
    return {
      listApi: getAdCount,
      searchInfo: {
        server_id: []
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      tableColumn: [{
        field: "date_str",
        title: "日期",
        sortable: true,
        width: 100
      }, {
        field: "new_user",
        title: "新增",
        sortable: true,
        width: 80
      }, {
        field: "new_role",
        title: "创角",
        sortable: true,
        visible: false,
        width: 80
      }, {
        field: "activity_user",
        title: "活跃",
        sortable: true,
        width: 80
      }, {
        field: "new_watchers_count",
        title: "新增广告人数",
        titleHelp: {
          "content": "新增广告率 = 新增广告人数 / 创角"
        },
        sortable: true,
        width: 150,
        slots: {
          default: function _default(_ref) {
            var row = _ref.row;
            return [h("span", [row.new_watchers_count, "\uFF08", row.new_watch_video_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "new_user_watch_video_count",
        title: "新增广告",
        sortable: true,
        width: 80
      }, {
        field: "new_average_watch_video_count",
        title: "新增人均广告",
        titleHelp: {
          "content": "新增人均广告次数 = 新增广告次数 / 新增广告人数"
        },
        sortable: true,
        width: 80
      }, {
        field: "watchers_count",
        title: "广告人数",
        titleHelp: {
          "content": "广告率 = 广告人数 / 活跃角色"
        },
        sortable: true,
        width: 150,
        slots: {
          default: function _default(_ref2) {
            var row = _ref2.row;
            return [h("span", [row.watchers_count, "\uFF08", row.watch_video_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "watch_video_count",
        title: "广告次数",
        sortable: true,
        width: 80
      }, {
        field: "average_watch_video_count",
        title: "人均广告",
        sortable: true,
        width: 80
      }, {
        field: "old_watchers_count",
        title: "老用户广告人数",
        titleHelp: {
          "content": "老用户广告率 = 老用户广告人数 / (活跃角色 - 创角 - 去广告老用户)"
        },
        sortable: true,
        width: 150,
        slots: {
          default: function _default(_ref3) {
            var row = _ref3.row;
            return [h("span", [row.old_watchers_count, "\uFF08", row.old_watch_video_rate, "%\uFF09"])];
          }
        }
      }, {
        field: "old_watch_video_count",
        title: "老用户广告",
        width: 80,
        titleHelp: {
          "content": "广告次数 - 新增广告次数"
        },
        sortable: true
      }, {
        field: "old_average_watch_video_count",
        title: "老用户人均广告",
        width: 80,
        titleHelp: {
          "content": "老用户人均广告次数 = 老用户广告次数 / 老用户广告人数"
        },
        sortable: true
      }, {
        field: "ad_free_old_users",
        title: "去广告老用户",
        width: 60,
        titleHelp: {
          "content": "30天内有充值高级月卡，当天有登录，且非当天注册的用户数量"
        },
        sortable: true,
        visible: false
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.searchEvent();
            _this.footDataToFirst();
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    footDataToFirst: function footDataToFirst() {
      var arr1 = document.getElementsByClassName("vxe-table--footer-wrapper");
      var arr2 = document.getElementsByClassName("vxe-table--body-wrapper");
      if (arr2[0]) {
        arr2[0].parentNode.insertBefore(arr1[0], arr2[0]);
      }
    },
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    loadTatleData: function loadTatleData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData) {
                _this2.$message({
                  message: "暂无数据"
                });
              } else if (_this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};